import { IAppConstants } from '../app.constants';
import { IPromise, IHttpResponse } from 'angular';

export class BaseUrlService {
    static $inject: string[] = ['configuration', 'store'];

    private baseUrl: string;
    private user: any;

    constructor(
        private configuration: IAppConstants,
        private store: ng.a0.storage.IStoreService
    ) {
        this.baseUrl = configuration.restServer;
        this.user = store.get('user');
        // if (this.user && this.user.accountData && !configuration.testEnvironment) {
        //     this.baseUrl = `https://${this.user.accountData.serverInstance}`;
        // }
    }

    getBaseUrl(): string {
        return this.baseUrl;
    }

    // setBaseUrl(url: string) {
    //     let protocol = 'https://';
    //     if (this.configuration.testEnvironment) {
    //         protocol = 'http://';
    //         return;
    //     }
    //     if (url.indexOf('http') !== -1) {
    //         this.baseUrl = `${url}`;
    //     } else {
    //         this.baseUrl = `${protocol}${url}`;
    //     }
    // }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/base-url.service.ts